<template>
  <div class="outline-main-wrapper">
    <app-left-right
        adapt-type="flex"
        :leftShadow="leftShadow"
        :leftWidth="leftWidth">
      <template #left>
        <div class="outline-wrapper"
             @mouseenter="outlineMouseEnter()">
          <div v-for="item in outlineContents"
               :key="item.id"
               :class="['bookmark', selectedId === item.id ? 'active' : '']"
               @click="onBookmarkClick(item)">
            {{item.label}}
          </div>
        </div>
      </template>
      <template #right>
        <div class="main-wrapper">
          <div class="fixed-top-wrapper">
            <slot name="fixed-top"></slot>
          </div>
          <div ref="scrollRect"
               class="scroll-wrapper"
               v-record-scroll
               @mouseenter="contentMouseEnter()"
               @scroll="throttleScroll">
              <slot></slot>
          </div>
        </div>
      </template>
    </app-left-right>
  </div>
</template>

<script>
  import { generateUUID } from '@/utils/common'
  import emitter from '@/minxins/emitter'
  import { throttle } from 'lodash'
  import { type } from "@/utils/common";

  export default {
    name: "app-outline-main",
    componentName: "app-outline-main",
    mixins: [emitter],
    props: {
      leftWidth: {
        type: String,
        default: '180px'
      },
      leftShadow: {
        type: Boolean,
        default: false
      },
      el: {
        type: [Object, String]
      }
    },
    data() {
      return {
        selectedId: null,
        scrollRect: null,
        outlineContents: [],
        enableListenScroll: false,
        throttleScroll: throttle(this.contentScroll, 50)
      }
    },
    computed: {
      scrollEl ({ el }) {
        return el ? type(el) === 'string' ? document.querySelector(el) : el : this.$refs.scrollRect
      }
    },
    created() {
      this.$on('app.outlineContent.addOutlineContent', (outlineItem) => {
        const id = outlineItem.name ? outlineItem.name : `outline-${generateUUID()}`;
        this.outlineContents.push({
          id,
          label: outlineItem.label,
          $el: outlineItem.$el
        });
        // 设置默认ID
        if (!this.selectedId) {
          this.selectedId = id;
        }
      });
    },
    mounted() {
      this.scrollRect = this.$refs.scrollRect.getBoundingClientRect();
    },
    methods: {
      onBookmarkClick(item) {
        this.selectedId = item.id;
        this.scrollToItem(item.$el);
      },
      contentScroll() {
        if (!this.enableListenScroll) {
          // 未启用滚动监听，直接跳过；防止scrollToItem自动滚动时，下面的监听逻辑重复运行
          return;
        }
        for (let item of this.outlineContents) {
          const e = item.$el;
          const itemRect = e.getBoundingClientRect();
          if (itemRect.top >= this.scrollRect.top || itemRect.bottom >= this.scrollRect.bottom) {
            this.selectedId = item.id;
            break;
          }
        }
      },
      outlineMouseEnter() {
        this.enableListenScroll = false;
      },
      contentMouseEnter() {
        this.enableListenScroll = true;
      },
      scrollToItem(anchorEle){
        if (anchorEle) {
          this.scrollEl.scrollTo({
            top: anchorEle.offsetTop - 93,
            left: 0,
            behavior: 'smooth'
          })
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  $paddingRight: 20px;
  /deep/ .left-shadow {
    box-shadow: 0 2px 11px 0 rgba(190, 202, 218, 0.17);
    border-radius: 4px;
  }
  .outline-main-wrapper {
    height: 100%;
    // padding: 10px 0 10px $paddingRight;
  }
  .outline-wrapper,
  .main-wrapper {
    height: 100%;
  }
  .outline-wrapper {
    background: #fff;
  }
  .main-wrapper {
    display: flex;
    flex-direction: column;
  }
  .bookmark {
    font-size: 14px;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
    font-weight: bold;

    &.active {
      // font-size: 14px;
      color: #1F6EEF!important;
      border-right: 4px solid #1F6EEF;
      background: #edf7ff;
      // font-weight: bold;
    }
    &:hover {
      font-size: 14px;
      color: #333;
      background: #edf7ff;
    }
  }
  .fixed-top-wrapper {
    margin-bottom: 10px;
    padding-right: $paddingRight;
  }
  .scroll-wrapper {
    flex: 1;
    overflow: auto;
  }
</style>
